import { IPredictedLineupsHp, PredictedLineupsHp } from "@sky-it-livedata/livedata-sports-design-system";

import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { CompetitionPredictedLineupsQuery } from "./types";

import transformer from "./transformers/query";
import { useIntcmp } from "../../hooks/useIntcmp";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<CompetitionPredictedLineupsQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

export const getServerProps = ({
  props,
}: WidgetContext<CompetitionPredictedLineupsQuery>): IPredictedLineupsHp => {
  return transformer(props);
}

const CompetitionPredictedLineupsWidget = ({
  props,
  ...rest
}: WidgetContext<IPredictedLineupsHp>) => {
  log({ props, ...rest });
  const intCmpEventHandler = useIntcmp();

  return (
    <div onClick={intCmpEventHandler}>
        <PredictedLineupsHp {...props} />
    </div>
  );
}

export default CompetitionPredictedLineupsWidget;